import { useState } from "react";
import { LuLoaderCircle } from "react-icons/lu";

export default function Button({
  id,
  children,
  onClick,
  className,
  icon,
  type,
  htmlFor,
  disabled,
  size = "md",
  title,
}) {
  const [updating, setUpdating] = useState(false);
  const types = {
    primary:
      "bg-primary text-primary-foreground border shadow hover:bg-primary/90 ",
    secondary:
      "bg-secondary text-secondary-foreground border shadow hover:bg-secondary/80 ",
    danger:
      "bg-destructive text-destructive-foreground border border-destructive shadow hover:bg-destructive/90 ",
    confirm:
      "bg-green-600 text-white border border-green-600 shadow hover:bg-green-500 ",
    "danger-ghost": "text-red-700 hover:text-red-500",
  };
  const sizes = {
    md: "p-2",
    sm: "py-1 px-2 text-[10px]",
    xs: "p-1 text-[10px] rounded-sm",
    lg: "p-3",
  };

  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) {
      try {
        setUpdating(true);
        await onClick();
        setUpdating(false);
      } catch (error) {
        console.error(error);
      } finally {
        setUpdating(false);
      }
    }
  };

  return (
    <button
      id={id}
      htmlFor={htmlFor}
      disabled={updating || disabled}
      title={title}
      className={`${types[type] || types.primary} ${sizes[size] || sizes.md} rounded-md flex items-center justify-center gap-2 text-xs cursor-pointer ${className} disabled:pointer-events-none disabled:opacity-60`}
      onClick={handleClick}>
      {icon && !updating && icon}
      {updating && (
        <div className="animate-spin">
          <LuLoaderCircle className="text-gray-500 text-sm" />
        </div>
      )}
      {children}
    </button>
  );
}
